import { Checkbox } from '@cian/ui-kit/prev';
import classNames from 'classnames';
import { useFormikContext, Field, getIn } from 'formik';
import * as React from 'react';

import { Label } from './Label';
import * as styles from './styles.css';
import { IFormValues } from '../SecondStep';

export const useFieldHasErrors = (name: keyof IFormValues) => {
  const { touched, errors } = useFormikContext<IFormValues>();

  return Boolean(getIn(touched, name) && getIn(errors, name));
};

export const IsTermAccepted = () => {
  const invalid = useFieldHasErrors('termAccepted');
  const { values } = useFormikContext<IFormValues>();

  return (
    <div className={classNames(styles['field'], styles['span-columns'])}>
      <Field
        name="termAccepted"
        as={Checkbox}
        checked={values.termAccepted}
        custom={{
          invalid,
          label: <Label invalid={invalid} />,
        }}
      />
    </div>
  );
};
